import { ref, toRefs, reactive } from 'vue';
import { defineStore } from 'pinia';

export const usePlayerState = defineStore('playerState', () => {
  const ingLoadingCount = ref(0);
  // 画板信息
  const canvasOptions = reactive({
    width: 0,
    height: 0
  });
  // 要播放的总帧数
  const playerConfig = reactive({
    frameCount: 0,
    playerWidth: 1920 / 6,
    playerHeight: 1080 / 6
  });
  const existVideo = ref(false);
  const playStartFrame = ref(0); // 当前播放帧
  const playTargetTrackMap = ref(new Map()); // 当前播放的元素集合
  const isPause = ref(true);
  /** 播放头拖拽中：预览层跳过真实 media seek，松手后再对齐 */
  const isScrubbing = ref(false);

  return {
    isPause,
    isScrubbing,
    playStartFrame,
    ingLoadingCount,
    playTargetTrackMap,
    existVideo,
    ...toRefs(playerConfig),
    canvasOptions
  };
});
